module.exports = {
  title: 'Tab Navigation with React Native Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-11-12',
  slug: 'tab-navigation',
  tags: ['reanimated', 'react-navigation'],
};
